import { Helmet } from "react-helmet-async";
// @mui
import { Container } from "@mui/material";
import Document from "src/components/Document/Document";
// ----------------------------------------------------------------------

export default function ProcessAssociateDocument() {
  return (
    <>
      <Helmet>
        <title> Process Associate Document </title>
      </Helmet>

      <Container maxWidth="xl">
        <Document Role="Process-Associate-MIS" />
      </Container>
    </>
  );
}
